import React from 'react'
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row
} from 'reactstrap'
import { connect } from 'react-redux'
import Swal from 'sweetalert2'

import GLOBAL from '../../../GLOBAL'

import UserModel from '../../../models/UserModel'

const user_model = new UserModel()

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user_username: '',
      user_password: '',
    }
  }

  componentDidMount() {
    if (this.props._user.user_code !== undefined) {
      this.props.history.push('/#/dashboard')
    }
  }

  async _handleSubmit(event) {
    event.preventDefault()

    const login_user = await user_model.checkLogin({
      user_username: this.state.user_username,
      user_password: this.state.user_password,
    })

    if (login_user.require === false) {
      Swal.fire({
        title: "Can not login!",
        text: "Sorry, Someting worng!",
        icon: 'error',
        button: "Close",
      })
    } else if (login_user.data.length === 0) {
      Swal.fire({
        title: "Can not login!",
        text: "Please check your username and password!",
        icon: "warning",
        button: "Close",
      })
    } else {
      localStorage.setItem('x-access-token', login_user.access_token)
      localStorage.setItem('permission-token', login_user.permission_token)

      GLOBAL.AUTH_HEADERS['x-access-token'] = login_user.access_token

      this.props.setUser(login_user.data[0])
    }
  }

  render() {
    return (
      <Form onSubmit={this._handleSubmit.bind(this)}>
        <div className="app flex-row align-items-center background-login">
          <Container>
            <Row className="justify-content-center">
              <Col md="6">
                <CardGroup>
                  <Card className="p-4  background-login-card">
                    <CardBody>
                      <h1>Login</h1>
                      <p className="text-muted">Sign In to your account</p>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-user"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          placeholder="Username"
                          autoComplete="username"
                          value={this.state.user_username}
                          onChange={(e) => this.setState({ user_username: e.target.value })}
                          aria-describedby="inputGroupPrepend21"
                          required
                        />
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="password"
                          placeholder="Password"
                          value={this.state.user_password}
                          onChange={(e) => this.setState({ user_password: e.target.value })}
                          autoComplete="current-password"
                          required
                        />
                      </InputGroup>
                      <Row>
                        <Col xs="6">
                          <Button color="primary" className="px-4">Login</Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>
      </Form>
    )
  }
}

const mapStatetoProps = (state) => {
  return {
    _user: state._user,
  }
}
const mapDispatchtoProps = (dispatch) => {
  return {
    setUser: (data) => {
      dispatch({
        type: "setUserLogin",
        payload: data
      })
    },
    setPermission: (data) => {
      dispatch({
        type: "setPermission",
        payload: data
      })
    }
  }
}

export default connect(mapStatetoProps, mapDispatchtoProps)(Login)